/** The client-changed card (unit convention §1). `index.tsx` renders it as a
 * sibling after `<PlayChessV2Body/>`. */
import React from 'react';

import {useClientChangedModel} from './model';
import ClientChangedView from './View';

export default React.memo(function ClientChanged() {
  return <ClientChangedView {...useClientChangedModel()} />;
});
